import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AccountClient, UserAccountClient} from '../models/models.swagger.generated';
import {SpinnerService} from '../spinner/spinner.service';
import { TranslateModule } from '@ngx-translate/core';

import { TitleBarComponent } from '../shared/title-bar/title-bar.component';

@Component({
    selector: 'app-confirm-email',
    templateUrl: './confirm-email.component.html',
    styleUrls: ['./confirm-email.component.scss'],
    imports: [TitleBarComponent, TranslateModule]
})
export class ConfirmEmailComponent implements OnInit {

  public success = false;

  constructor(
    public spinnerService: SpinnerService,
    private route: ActivatedRoute,
    private userAccountClient: UserAccountClient,
  ) { }

  ngOnInit(): void {
    this.spinnerService.showSpinner = true;

    this.route.queryParams.subscribe(params => {
      if (params.userId != null || params.code != null) {
        this.userAccountClient.confirmEmail(params.userId, params.code).subscribe( ()=> {
          this.spinnerService.showSpinner = false;
          this.success = true;
        }, () => {
          this.spinnerService.showSpinner = false;
          this.success = false;
        });
      } else {
        this.spinnerService.showSpinner = false;
      }
    }, () => {
      this.spinnerService.showSpinner = false;
    });

  }

}
